import { get } from '@ember/object';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import Checkbox, { type Signature as CheckboxSignature } from '../checkbox.gts';

interface Signature {
  Args: {
    changeset: EmberChangeset;
    payloadKey: string;
    onChangesetUpdate?: (changeset: EmberChangeset) => void;
  } & CheckboxSignature['Args'];
  Element: HTMLElement;
}

/**
 * This component manages two types of data depending of the simple selection or
 * the multiple selection.
 *
 * - A single selection manage a string
 * - A multiple selection manage an array of strings.
 *
 * It can used using a changeset or as a classic component with an
 * `onChange` callback and `selected` attribute.
 */
export default class ChangesetCheckboxComponent extends Component<Signature> {
  onChange = (value: boolean): void => {
    this.args.changeset.set(this.args.payloadKey, value);
    this.args.onChangesetUpdate?.(this.args.changeset);
  };

  <template>
    <Checkbox
      @labelName={{@labelName}}
      @isMandatory={{@isMandatory}}
      {{! @glint-expect-error }}
      @checked={{get @changeset @payloadKey}}
      @onChange={{this.onChange}}
      @dataTestInput={{@dataTestInput}}
      @payloadKey={{@payloadKey}}
      @disabled={{@disabled}}
      @isReadOnly={{@isReadOnly}}
      ...attributes
    />
  </template>
}
